import type { InlineModel } from '@flipp/shopper-ad-web-schemas';
import { Tags } from '@flipp/shopper-ad-web-shared';

const LARGE_AD_AREA = 242500;

// Sends AdMixer's viewable trackers once the rendered ad is MRC viewable:
// at least 50% of its area in view (30% for ads over 242,500 px²) for 1 s,
// counted from when the ad frame has loaded.
export const watchAdmixerViewable = (
  frame: Readonly<HTMLIFrameElement>,
  decision?: Readonly<InlineModel>,
): null => {
  if (
    !decision?.storefront?.campaignConfig?.tags?.admixer?.viewableImpression
      ?.length
  ) {
    return null;
  }
  frame.addEventListener(
    'load',
    () => {
      // eslint-disable-next-line functional/no-let
      let timer: number | undefined;
      const observer = new IntersectionObserver(
        entries => {
          const { boundingClientRect: rect, intersectionRatio } =
            entries[entries.length - 1];
          const viewable =
            intersectionRatio >=
            (rect.width * rect.height > LARGE_AD_AREA ? 0.3 : 0.5);
          if (viewable && !timer) {
            timer = window.setTimeout(() => {
              observer.disconnect();
              Tags.sendViewableImpression();
            }, 1000);
          } else if (!viewable && timer) {
            window.clearTimeout(timer);
            timer = undefined;
          }
        },
        { threshold: [0, 0.3, 0.5] },
      );
      observer.observe(frame);
    },
    { once: true },
  );
  return null;
};
